import React, { useState, useEffect } from 'react';
import { FaSave, FaCheck, FaTimes, FaEye } from 'react-icons/fa';
import { Oval } from 'react-loader-spinner';
import styles from './AdminDefinitionsPage.module.css';
import { db } from '../config/firebaseConfig';
import { collection, doc, getDoc, setDoc, updateDoc, getDocs } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { menuItems } from '../components/SideBar';

const AdminDefinitionsPage = () => {
  const [restrictedAdminPermissions, setRestrictedAdminPermissions] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchRestrictedAdminPermissions();
  }, []);

  const fetchRestrictedAdminPermissions = async () => {
    try {
      setIsLoading(true);
      const restrictedAdminRef = doc(db, 'AdminDefinitions', 'restrictedAdminPermissions');
      const docSnap = await getDoc(restrictedAdminRef);
      
      if (docSnap.exists()) {
        setRestrictedAdminPermissions(docSnap.data());
      } else {
        // Initialize with default permissions if document doesn't exist
        const defaultPermissions = {};
        menuItems.forEach(item => {
          defaultPermissions[item.path] = false;
          if (item.submenu) {
            item.submenu.forEach(subItem => {
              defaultPermissions[subItem.path] = false;
            });
          }
        });
        setRestrictedAdminPermissions(defaultPermissions);
      }
    } catch (error) {
      console.error('Error fetching Kısıtlı Admin permissions:', error);
      toast.error('Kısıtlı Admin izinleri yüklenirken bir hata oluştu.');
    } finally {
      setIsLoading(false);
    }
  };

  const togglePermission = (path) => {
    setRestrictedAdminPermissions(prev => ({
      ...prev,
      [path]: !prev[path]
    }));
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const restrictedAdminRef = doc(db, 'AdminDefinitions', 'restrictedAdminPermissions');
      
      // Check if document exists
      const docSnap = await getDoc(restrictedAdminRef);
      
      if (docSnap.exists()) {
        await updateDoc(restrictedAdminRef, restrictedAdminPermissions);
      } else {
        await setDoc(restrictedAdminRef, restrictedAdminPermissions);
      }
      
      toast.success('Kısıtlı Admin izinleri başarıyla kaydedildi!');
    } catch (error) {
      console.error('Error saving Kısıtlı Admin permissions:', error);
      toast.error('Kısıtlı Admin izinleri kaydedilirken bir hata oluştu: ' + error.message);
    } finally {
      setIsSaving(false);
    }
  };

  const renderMenuItems = (items) => {
    return items.map((item, index) => (
      <div key={index} className={styles.menuItem}>
        <div className={styles.menuHeader}>
          <div className={styles.menuTitle}>
            <span className={styles.menuIcon}>{item.icon}</span>
            <span>{item.title}</span>
          </div>
          <button
            className={`${styles.toggleButton} ${restrictedAdminPermissions[item.path] ? styles.active : ''}`}
            onClick={() => togglePermission(item.path)}
            disabled={isSaving}
          >
            {restrictedAdminPermissions[item.path] ? <FaCheck /> : <FaTimes />}
          </button>
        </div>
        
        {item.submenu && item.submenu.length > 0 && (
          <div className={styles.submenu}>
            {item.submenu.map((subItem, subIndex) => (
              <div key={subIndex} className={styles.submenuItem}>
                <div className={styles.menuTitle}>
                  <span className={styles.submenuIcon}>{subItem.icon}</span>
                  <span>{subItem.title}</span>
                </div>
                <button
                  className={`${styles.toggleButton} ${restrictedAdminPermissions[subItem.path] ? styles.active : ''}`}
                  onClick={() => togglePermission(subItem.path)}
                  disabled={isSaving}
                >
                  {restrictedAdminPermissions[subItem.path] ? <FaCheck /> : <FaTimes />}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    ));
  };

  if (isLoading) {
    return (
      <div className={styles.container} aria-busy="true">
        <div className={styles.header}>
          <h1 className={styles.title}>
            <span>Kısıtlı Admin Tanımlamaları</span>
          </h1>
        </div>
        <div className={styles.loadingContainer}>
          <Oval
            color="#4f46e5"
            secondaryColor="#818cf8"
            height={50}
            width={50}
            visible={true}
          />
          <p>Yükleniyor, lütfen bekleyin...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          <span>Kısıtlı Admin Tanımlamaları</span>
        </h1>
      </div>

      <div className={styles.formContainer}>
        <p className={styles.helperText}>
          Kısıtlı admin kullanıcılarının erişebileceği menüleri seçin. 
          Seçilen menüler ve alt menüler kısıtlı admin kullanıcıları tarafından görüntülenebilecektir.
        </p>

        <div className={styles.menuList}>
          {renderMenuItems(menuItems)}
        </div>

        <div className={styles.buttonContainer}>
          <button
            type="button"
            onClick={handleSave}
            className={styles.saveButton}
            disabled={isSaving}
            aria-busy={isSaving}
          >
            <FaSave size={14} aria-hidden="true" />
            <span>{isSaving ? 'Kaydediliyor...' : 'Kaydet'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminDefinitionsPage; 